import React from 'react';

import UploadFileIcon from '@mui/icons-material/UploadFile';

import { useImageLoadFailure } from './useImageLoadFailure';
import { AuditAttachment } from './types';
import { ThumbFallback, ThumbFilename, ThumbImage, ThumbLink } from './styles';

type AuditAttachmentThumbProps = {
  questionKey: string;
  file: AuditAttachment;
};

const AuditAttachmentThumb: React.FunctionComponent<AuditAttachmentThumbProps> = ({ questionKey, file }) => {
  const [failed, onError] = useImageLoadFailure(file.url);

  return (
    <ThumbLink href={file.url} target="_blank" rel="noopener noreferrer" title={file.filename}>
      {failed ? (
        // Still a link: a file that won't render as an image can usually be opened.
        <ThumbFallback data-testid={`audit-attachment-unavailable-${questionKey}`}>
          <UploadFileIcon />
          <ThumbFilename>{file.filename}</ThumbFilename>
        </ThumbFallback>
      ) : (
        <ThumbImage
          src={file.url}
          loading="lazy"
          alt={file.filename}
          onError={onError}
          data-testid={`audit-attachment-image-${questionKey}`}
        />
      )}
    </ThumbLink>
  );
};

export default AuditAttachmentThumb;
